import React, { Suspense } from "react";
import { Grid } from "semantic-ui-react";
import { Loading } from "../../../components/common";

interface IFallBack {
  children: any;
  inverted?: boolean;
}
class FallBack extends React.Component<IFallBack> {
  public render() {
    return (
      <Suspense
        fallback={
          <Grid celled padded style={{ height: "100vh" }}>
            <Loading
              above
              style={styles.bg}
              active
              inverted={this.props.inverted}
            />
          </Grid>
        }
      >
        {this.props.children}
      </Suspense>
    );
  }
}
const styles: any = {
  bg: {
    background: "rgba(255, 255, 255, 0.8)",
  },
};
export default FallBack;
